/**
 * PanelMapService — 지도(MapHost) 생성 및 플러그인 관리
 *
 * Pure JS: Vue 의존성 없음, 명시적 콜백으로 결과 전달
 */
import {
  createPanelPlanningMapHost,
  createPanelPlanningMapPluginContext,
  attachPanelPlanningMapPlugins
} from '@/features/panel-planning/map';
import { applyPanelTranslateModifyBindings } from '@/features/panel-planning/utils/panelTranslateModifyBindings';

export function createPanelMapService() {
  /** @type {import('@/features/panel-planning/map').OpenLayersMapHost|null} */
  let mapHost = null;

  return {
    getMapHost: () => mapHost,

    initMap(targetId, renderer = 'canvas') {
      mapHost = createPanelPlanningMapHost(targetId, {
        attachCursorPlugin: false,
        renderer
      });
      return extractMapRefs(mapHost);
    },

    initPlugins(vmRef, pluginList) {
      if (!mapHost) return;
      const ctx = createPanelPlanningMapPluginContext(vmRef);
      attachPanelPlanningMapPlugins(mapHost, ctx, pluginList);
    },

    updateTranslate(refs, handlers = {}) {
      if (!mapHost) return;
      const map = mapHost.getMap();
      if (!map) return;
      applyPanelTranslateModifyBindings(map, {
        groupSelection: refs.groupSelection,
        moduleSelection: refs.moduleSelection,
        modifyInteraction: refs.modifyInteraction,
        translateInteraction: refs.translateInteraction,
        handlers,
        assignInteractions: ({ modifyInteraction, translateInteraction }) => {
          refs.modifyInteraction = modifyInteraction;
          refs.translateInteraction = translateInteraction;
        }
      });
    },

    destroy() {
      if (mapHost) {
        mapHost.destroy();
        mapHost = null;
      }
    }
  };
}

function extractMapRefs(host) {
  return {
    map: host.getMap(),
    view: host.getView(),
    vectorSource: host.getVectorSource(),
    vectorLayer: host.getVectorLayer(),
    satelliteTileLayer: host.getLayer('satellite'),
    siteImageTileLayer: host.getLayer('siteImage')
  };
}
